
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Family } from '@/types/models';
import { UseFormReturn } from 'react-hook-form';
import { InvoiceFormValues } from '../hooks/useInvoiceForm';

interface FamilySelectFieldProps {
  form: UseFormReturn<InvoiceFormValues>;
  families: Family[];
}

export const FamilySelectField: React.FC<FamilySelectFieldProps> = ({ form, families }) => {
  return (
    <FormField
      control={form.control}
      name="family_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Family</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a family" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {families.map((family) => (
                <SelectItem key={family.id} value={family.id}>
                  {family.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
